<header class="main-navigation-header">
  <div class="container">
    <div class="main-navigation-header__logotype">
      <pds-logotype />
      <span class="main-navigation-header__logotype__divider"></span>
      <span>Developers</span>
    </div>
  </div>
</header>

<main class="main-navigation">
  <router-outlet />
</main>

<footer class="main-navigation-footer"></footer>
